module.exports = __webpack_public_path__ + "static/media/1pic.dddc5e96.png";